export default "__VITE_ASSET__0bb54dad__"